import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
export default function extendUserModel() {
  Object.assign(User.prototype, {
    classifiedsListingsCount: Model.attribute('classifiedsListingsCount')
  });
}
flarum.reg.add('ramon-classifieds', 'common/extendUserModel', extendUserModel);